import { Box, ThemeProvider, Typography } from "@mui/material";
import React, { Suspense, memo, startTransition, useEffect, useState } from "react";
import { useNavigate, useRoutes } from "react-router-dom";

import theme from "./theme";
const Header = React.lazy(() => import("./layouts/Header"));
import { routes } from "./routes/TenantRoutes";

import ErrorBoundary from "./components/error-boundary/ErrorBoundary";
import Toast from "MyAccountPlus-UIComponents/src/components/utils/Toast";
import Loader from "MyAccountPlus-UIComponents/src/components/utils/Loader";
import LazyLoader from "MyAccountPlus-UIComponents/src/components/lazy-loader/LazyLoader";

import { useAppDispatch, useAppSelector } from "./store/hooks";
import { appSettingActions, appSettingThunk } from "./store/app-setting-reducer/appSettingSlice";

import { SnackbarInterface } from "MyAccountPlus-UIComponents";

import "./app.scss";

const App = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const content = useRoutes(routes);

  const { error } = useAppSelector((state) => state.appSettingStore);
  const tenant = localStorage.getItem("tenant") || "";

  const [snackbar, setSnackbar] = useState<SnackbarInterface>({
    open: false,
    message: "",
    severity: "info",
  });

  const handleCloseSnackbar = () => {
    setSnackbar({
      open: false,
      message: "",
      severity: "info",
    });
    if (error?.length > 0) {
      dispatch(appSettingActions.errorReducer());
    }
  };

  useEffect(() => {
    if (error?.length) {
      setSnackbar({
        open: true,
        message: error,
        severity: "error",
      });
    }
  }, [error]);

  useEffect(() => {
    (window.location.pathname === "/admin" || window.location.pathname === "/admin/") &&
      navigate("/admin/accounts", { replace: true });
  }, [navigate]);

  useEffect(() => {
    startTransition(() => {
      dispatch(appSettingThunk());
    });
  }, [dispatch]);

  // if (tenant.length === 0 && !loading) {
  //   return (
  //     <Typography className="error-text">
  //       There was an error communicating with the server.
  //     </Typography>
  //   );
  // }

  // if (loading) return <Loader open={loading} />;

  return (
    <ThemeProvider theme={theme}>
      {snackbar.open && <Toast snackbar={snackbar} handleCloseSnackbar={handleCloseSnackbar} />}

      <Box className="main-wrapper-box">
        <Suspense fallback={<LazyLoader />}>
          <Header />
        </Suspense>
        <Suspense fallback={<LazyLoader />}>
          <Box className="content-body">{content}</Box>
        </Suspense>
      </Box>
    </ThemeProvider>
  );
};

export default memo(App);